import { BASE_URL } from "../../utils/EmpUtil";
import axios from "axios";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { is401 } from "../../errors/ErrorConstants";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";

export default class NscNotificationsClient {
  static baseUrl = BASE_URL;

  static getNscOrderAcceptanceNotifications(user, currentPage, market) {
    const url = `${this.baseUrl}/${market}/notifications/messages?currentPage=${currentPage}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static deleteNotification(user, market, id) {
    const url = `${this.baseUrl}/${market}/notifications/delete?id=${id}`;

    return axios
      .delete(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
